"use client";

import { motion } from "motion/react";

const HeroDivider = () => {
  return (
    <div className="relative z-20 py-[2px]">
      {/* Soft ambient glow behind the line */}
      <div className="absolute inset-x-0 top-1/2 -translate-y-1/2 h-[30px] bg-gradient-to-r from-transparent via-theme/[0.04] to-transparent blur-[16px] pointer-events-none" />

      {/* The line itself — a gradient that fades at edges */}
      <div className="relative mx-auto max-w-[min(80%,900px)] h-[1px] overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/[0.08] to-transparent" />

        {/* Shimmer — a slow, wide sweep of light */}
        <motion.div
          className="absolute inset-y-0 w-[30%] bg-gradient-to-r from-transparent via-theme/25 to-transparent"
          initial={{ x: "-100%" }}
          animate={{ x: "400%" }}
          transition={{
            duration: 6,
            ease: [0.25, 0.1, 0.25, 1],
            repeat: Infinity,
            repeatDelay: 8,
          }}
        />
      </div>
    </div>
  );
};

export default HeroDivider;
